import { ChakraGrid } from '@equip.health/ui';

import OpsRoutes from './OpsRoutes';
import OpsNav from '../components/ops/OpsNav';
import Page from '../components/common/Page';
import { ComponentPortalContextProvider } from '../lib/contexts/ComponentPortalContext';

const OpsApp = () => (
  <ComponentPortalContextProvider>
    <ChakraGrid
      columnGap="24px"
      height="100%"
      templateColumns="auto 1fr"
      templateRows="1fr"
      width="100%"
    >
      <OpsNav />
      <Page>
        <OpsRoutes />
      </Page>
    </ChakraGrid>
  </ComponentPortalContextProvider>
);

export default OpsApp;
